import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import { Elements } from 'react-stripe-elements';
import { accountRoute } from '../../routes';

import connect from '../../utils/connect';
import translate from '../../utils/translate';

import Splitter from './block/splitter';
import ContentBlock from './block/content';
import ConfirmDialog from  '../form/confirm';
import Spinner from '../svg/spinner';

import Step1 from './jobCreate/step1';
import Step2 from './jobCreate/step2';
import Step3 from './jobCreate/step3';
import Step4 from './jobCreate/step4';

//import translate from '../../utils/translate';

import { redirectToAccountIfNoProfile } from '../../utils/authorization';

const JOB_STEP0 = 0;
const JOB_STEP1 = 1;
const JOB_STEP2 = 2;
const JOB_STEP3 = 3;
const JOB_STEP4 = 4;

import css from './caseCreate.scss';

class AccountJobCreate extends Component {

	constructor(props) {
		super();

		this.state = {
			waiting: false,
			step: JOB_STEP0,
			customerInfo: {},
			slug: '',
			skipPayment: !!(props.users.profile && props.users.profile.hasFreeSubmission),
		};
	}

	componentWillMount() {
		//redirectToAccountIfNoProfile(this.props.dispatch, this.props.users);
	}

	componentWillReceiveProps(nextProps) {}

	render() {
		const introText = translate('account/jobcreate/intro', true, true);
		//console.log(introText);

		return (
			<div className='account-process'>
				<Helmet title='The FWA - Account - Submit Job' />

				<ContentBlock title=''>
					<div className='account-process__title-area' dangerouslySetInnerHTML={{ __html: introText }} />
				</ContentBlock>

				<ContentBlock className='pixel-pattern pixel-pattern--01'>
					<div className='account-process__button-area'>
						{(this.state.step === JOB_STEP0) && (
							<button className='button--dark' onClick={() => this.start()}>{translate('account/jobcreate/startButton')}</button>
						)}
						<span className='account-process__button-area__button-desc'><span className='hide-mobile'>{translate('account/jobcreate/startText')}</span> {translate('account/jobcreate/startTextPrice')}</span>
					</div>
				</ContentBlock>

				<Step1
					dispatch={this.props.dispatch}
					activeStep={this.state.step}
					goToStep={() => this.goToStep(JOB_STEP1)}
					goForward={() => this.goForward()}
					onSubmit={(pr, st) => this.onSubmit(pr, st)}
					user={this.props.users}
				/>

				<Step2
					dispatch={this.props.dispatch}
					activeStep={this.state.step}
					skipPayment={this.state.skipPayment}
					goToStep={() => this.goToStep(JOB_STEP2)}
					goForward={() => this.goForward()}
					onSubmit={(pr, st) => this.onSubmit(pr, st)}
					skipToEnd={(st) => this.goToStep(JOB_STEP4, st)}
				/>
				<Elements>
					<Step3
						dispatch={this.props.dispatch}
						activeStep={this.state.step}
						goToStep={() => this.goToStep(JOB_STEP3)}
						goForward={() => this.goForward()}
						onSubmit={(pr, st) => this.onSubmit(pr, st)}
					/>
				</Elements>

				<Step4
					dispatch={this.props.dispatch}
					activeStep={this.state.step}
					goToStep={() => this.goToStep(JOB_STEP4)}
					goForward={() => this.goForward()}
					onSubmit={(pr, st) => this.onSubmit(pr, st)}
					slug={this.state.slug}
				/>

			</div>
		);
	}

	start() {
		if (this.state.step === JOB_STEP0) {
			this.setState({
				...this.state,
				step: JOB_STEP1,
			});
		}
	}

	onSubmit(promise, addedState = {}) {
		promise.then((res) => {
			let newState = {
				...this.state,
				...addedState,
			};

			this.goForward(newState);
		}).catch(() => {});
	}

	goForward(state) {
		let nextStep = (state.step + 1);

		if (nextStep === JOB_STEP3 && this.state.skipPayment) {
			nextStep++;
		}

		if (nextStep > JOB_STEP4) {
			return false;
		}

		if (nextStep < state.step) {
			return false;
		}

		this.setState({
			...state,
			step: nextStep,
		});
	}

	goBackwards() {
		let prevStep = this.state.step - 1;
		if (prevStep < JOB_STEP0) {
			return false;
		}

		this.setState({
			...this.state,
			step: prevStep,
		});
	}

	goToStep(step, addedState = {}) {
		let minStep = JOB_STEP0;
		let maxStep = JOB_STEP4;
		if (!(step >= minStep && step <= maxStep)) {
			return false;
		}

		this.setState({
			...this.state,
			...addedState,
			step: step,
		});
	}

	cycleSteps() {
		let nextStep = (this.state.step + 1) % 5;
		this.setState({
			...this.state,
			...addedState,
			step: nextStep,
		});
	}

	setWaiting(state) {
		this.setState({ ...this.state, waiting: state });
	}

	renderWaiting() {
		return (
			<div key='spinner' style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
				<Spinner size='60' />
			</div>
		);
	}
}

export default connect(AccountJobCreate);



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jobCreate.js
 **/